import L, {TileLayer} from "leaflet";
import 'leaflet';
import 'leaflet.gridlayer.googlemutant';

export enum MapLayerType {
  none = 0,
  emapa = 1,
  osm = 2,
  // osmTransport = 3,
  googleRoadmap = 4,
  googleHybrid = 5
}

// jest to osobna klasa ponieważ zgodnie z instrukcją dla pluginu minimapy należy użyć osobnych instancji warstw żeby nie działy się dziwne rzeczy
export class MapLayers {
  readonly emapaLayer = new TileLayer(
    'https://img1.emapi.pl/?fun=GetMap&zoom={z}&tileX={x}&tileY={y}&layer=std&userID=3uVpXregEaJHXg74', {
      minZoom: 2,
      maxZoom: 18
    });

  readonly osmLayer = new TileLayer(
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      minZoom: 2,
      maxZoom: 18
    });

  //wykorzystanie wstrzymane aż do wyjaśnienia czy będzie używane
  // static readonly osmTransportLayer = new TileLayer(
  //   'https://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png', {
  //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  //     minZoom: 2,
  //     maxZoom: 18
  //   });

  //jest do tego zainstalowany pakiet z typami @types/leaflet.gridlayer.googlemutant
  readonly googleStreetsLayer = L.gridLayer.googleMutant({
    type: "roadmap",
    minZoom: 2,
    maxZoom: 18
  });

  readonly googleHybridLayer = L.gridLayer.googleMutant({
    type: "hybrid",
    minZoom: 2,
    maxZoom: 18
  });

}
